import Filters from '@/utils/input/filters';
import BaseFilters from '@/utils/input/filters/BaseFilters';
import { registerModuleFilters } from '@/utils/input/filters';

const PowerBIServerConfigurationFilter = {
  ...BaseFilters.RemoteFilter,
  name: 'powerBIServerConfigurationId',
  label: 'reportGroups.form.powerBIServerConfigurationId',
  apiRoute: 'powerBIServerConfiguration/allowed',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name',
  },
};

const CreatedDateFilter = {
  ...Filters.DateFilter,
  name: 'created',
  label: 'global.created',
};

const UserCreatorFilter = {
  ...Filters.UserFilter,
  name: 'userCreatorId',
  label: 'global.userCreator',
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  name: 'updated',
  label: 'global.updated',
};

const UserModifierFilter = {
  ...Filters.UserFilter,
  name: 'userModifierId',
  label: 'global.userModifier',
};

export const filtersConfig = [
  PowerBIServerConfigurationFilter,
  Filters.IsActiveFilter,
  CreatedDateFilter,
  UserCreatorFilter,
  UpdatedDateFilter,
  UserModifierFilter,
];

export const groupsFiltersConfig = filtersConfig;

registerModuleFilters('reportGroups', filtersConfig);
